import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useAuth } from '@/hooks/useAuth';

export function useInventory() {
  const { user } = useAuth();

  return {
    getInventory: (params?: { location_id?: string; item_id?: string; low_stock_only?: boolean }) =>
      useQuery({
        queryKey: ['inventory', user?.hospital_id, params],
        queryFn: () => api.getInventory(params),
        enabled: !!user?.hospital_id,
      }),

    getLowStockItems: () =>
      useQuery({
        queryKey: ['low-stock', user?.hospital_id],
        queryFn: () => api.getLowStockItems(),
        enabled: !!user?.hospital_id,
      }),

    getTransactions: (params?: { item_id?: string; location_id?: string; transaction_type?: string; start_date?: string; end_date?: string; page?: number; page_size?: number }) =>
      useQuery({
        queryKey: ['transactions', user?.hospital_id, params],
        queryFn: () => api.getTransactions(params),
        enabled: !!user?.hospital_id,
      }),
  };
}
